import React, { useEffect, useState } from 'react';

const ComingSoonC = () => {
  // eslint-disable-next-line
  const [deadline] = useState('Jan, 26, 2023');
  const [hours, setHours] = useState<string | number>('0');
  const [seconds, setSeconds] = useState<string | number>('0');
  const [minutes, setMinutes] = useState<string | number>('0');

  const getTimeUntil = (deadline: string) => {
    const currentDate: any = new Date();

    const time: any = Date.parse(deadline) - Date.parse(currentDate);

    if (time < 0) {
      //   console.log('Date passed');
    } else {
      const seconds: number = Math.floor((time / 1000) % 60);
      const hours: number = Math.floor((time / (1000 * 60 * 60)) % 24);
      const minutes: number = Math.floor((time / 1000 / 60) % 60);

      setHours(hours);
      setSeconds(seconds);
      setMinutes(minutes);
    }
  };

  useEffect(() => {
    setInterval(() => getTimeUntil(deadline), 1000);
  });
  return (
    <div className='w-[763px] rounded-lg shadow-lgYellow bg-white h-[464px] mx-auto '>
      <header className='text-center pt-[45px]  '>
        <h1 className='font-extrabold text-[29px] font-Poppins  uppercase text-green '>
          Coming Soon
        </h1>
        <p className='text-xs text-black font-Poppins py-2 '>
          Our website is under maintenance. Let’s countdown to the big reveal.
        </p>
      </header>
      <section className='font_number  py-10'>
        <div className='flex justify-center space-x-8 '>
          <div className='border-[#F2C900] w-[132.53px] flex justify-center flex-col items-center rounded-full h-[132.53px] border-[0.662635px] '>
            <div className='text-[54px] text-center font_number  text-[#028789] '>{12}</div>
            <div className='text-[15px]  font-Poppins text-[#768396] '>Hours</div>
          </div>
          <div className='border-[#F2C900] w-[132.53px] flex justify-center flex-col items-center rounded-full h-[132.53px] border-[0.662635px] '>
            <div className='text-[54px] text-center font_number  text-[#028789] '>{'00'}</div>
            <div className='text-[15px]  font-Poppins text-[#768396] '>Minutes</div>
          </div>
        </div>
        {/* <div className='flex justify-center pt-[66px] '>
          <form className='w-[508.9px] flex  '>
            <input
              type='text'
              placeholder='Email here'
              className='py-3  w-full px-4 rounded-md border-[#F8B400] border-[0.837px] outline-none text-black '
            />
            <button
              style={{
                background: 'linear-gradient(111.09deg, #028789 11.48%, #6BB47B 95.74%',
              }}
              className='py-3 ml-[-10px] px-4 whitespace-nowrap rounded-md border-none outline-none text-white bg-[linear-gradient(111.09deg, #028789 11.48%, #6BB47B 95.74%]'
              type='button'
            >
              Notify me
            </button>
          </form>
        </div> */}
      </section>
    </div>
  );
};

export default ComingSoonC;
